<div class="input-wrap select">
  <select class="input" [(ngModel)]="value">
    <option [value]="''" selected="selected">
      {{ placeholder }}
    </option>

    <ng-container *ngFor="let option of panelsOptions">
      <option [value]="option.key">
        {{ option.value }}
      </option>
    </ng-container>
  </select>
</div>
